import React from "react";
import * as styles from "../navigation/navigation.module.scss";

/**
 * @type {Object} 「UI:atoms - ナビゲーション パンくず コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {Array} props コンポーネントを受け取るための引数です。コンポーネントに任意の値を渡します。（ref.https://ja.react.dev/learn/passing-props-to-a-component）
 * @param {Object} props.items 配列に設定した要素（テキストリンク）を受け取るための引数です。
 * @param {String} props.currentPageTitle カレントページのページタイトルを文字列で受け取るための引数です。
 * 
 */

const Breadcrumbs = (props) => {
  const listItems = props.items.map((listItem) => (
    <li key={listItem.id}>
      <a href={listItem.url}>{listItem.text}</a>
    </li>
  ));

  return (
    <nav className={`${styles.breadcrumbs}`} aria-label="Breadcrumbs">
      <ol>
        {listItems}
        <li key={"layerCurrent"}>{props.currentPageTitle}</li>
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
